import {
  BACKGROUND,
  BackgroundDefinition,
  BULLET_LIST,
  CARD,
  CardDefinition,
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { ListHelper } from './itemHelpers/ListHelper';
import { translate } from './translate';

export const List2: Translator = sequence => {
  const header: { title: string; subtitle: string; icon: string } = {
    title: '',
    subtitle: '',
    icon: ''
  };

  if (sequence && sequence.items) {
    sequence.items.forEach(item => {
      if (item.__typename === 'Text') {
        header.title = item.title || '';
        header.subtitle = item.subtitle || '';
        header.icon = item.icon || '';
      }
    });
  }

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'List':
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: {
            side: 'right'
          },
          items: [
            {
              type: CARD,
              id: '1',
              values: {
                width: '100%',
                height: 'auto'
              },
              items: [
                {
                  id: item.id,
                  type: LAYOUT_LIST,
                  values: {
                    align: 'left',
                    padded: false
                  },
                  items: [
                    {
                      type: TEXT,
                      id: `${item.id}_subtitle`,
                      items: [],
                      values: {
                        value: item.subtitle,
                        variant: 'sub_heading',
                        icon: item?.icon || ''
                      }
                    },
                    {
                      type: TEXT,
                      id: `${item.id}_title`,
                      items: [],
                      values: {
                        value: item.title,
                        variant: 'heading1'
                      }
                    },
                    {
                      type: BULLET_LIST,
                      id: item.id,
                      values: [],
                      items: ListHelper(item.items, 'checkmark')
                    },
                    {
                      type: TEXT,
                      id: 'bottom_text',
                      items: [],
                      values: {
                        value: header.title || '',
                        variant: 'text'
                      }
                    }
                  ]
                } as LayoutListDefinition
              ]
            } as CardDefinition
          ]
        } as LayoutHalfPageDefinition;
      default:
        return null;
    }
  });

  const bg = root.items.find(
    i => i.type === BACKGROUND
  ) as BackgroundDefinition;
  if (bg) {
    bg.values.direction = { _: 'column', lg: 'row' };
  }

  return root;
};
